import { Box, Chip, Grid, IconButton, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { EditIcon } from "../../icons";
import { useMemo, useState } from "react";
import { reportInspectionSampleData, reportSampleData } from "../../datas/reportSampleData";
import { buildReportMetrics } from "./reportMetrics";
import { DEFAULT_LAYOUT, REPORT_CONTENTS, ValidationInfo } from "./ReportContents";
import { useColorTheme } from "./setting/ColorThemeContext";

export const reportSectionSx = {
  height: "100%",
  border: "1px solid var(--border-color, #e0e0e0)",
  borderRadius: 2,
  p: 2,
  backgroundColor: "var(--report-card-bg, #fff)",
};

// 더미 데이터(DB 형태)로 구성한 읽기 전용 샘플 리포트
export default function SampleContent() {
  const { currentColors } = useColorTheme();
  const [step, setStep] = useState<"분석" | "검사">("분석");
  const [editedText, setEditedText] = useState(""); // 샘플은 저장하지 않음
  const [editing, setEditing] = useState(false);
  const m = useMemo(() => buildReportMetrics(step === "검사" ? reportInspectionSampleData : reportSampleData), [step]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: "var(--text-color)" }}>
          {m.projectName}
        </Typography>
        <Chip size="small" label="Sample" color="primary" variant="outlined" />
        <ToggleButtonGroup
          size="small"
          exclusive
          value={step}
          onChange={(_, v) => v && (setStep(v), setEditedText(""))}
          sx={{ ml: "auto" }}
        >
          <ToggleButton value="분석">분석</ToggleButton>
          <ToggleButton value="검사">검사</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Typography sx={{ mb: 2, fontSize: 14, color: "var(--text-secondary-color)" }}>
        제품 {m.materialName} · 클래스 {m.classes.join(", ")} · 더미 데이터로 생성된 예시 리포트입니다.
      </Typography>
      <ValidationInfo m={m} />
      <Grid container spacing={2}>
        {DEFAULT_LAYOUT.map(({ type, gridSize }) => {
          const { title, Component, editable } = REPORT_CONTENTS[type];
          return (
            <Grid item xs={12} md={gridSize} key={type}>
              <Box sx={reportSectionSx}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1.5,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "var(--text-secondary-color)",
                    }}
                  >
                    {title}
                  </Typography>
                  {editable && (
                    <IconButton size="small" onClick={() => setEditing(true)} sx={{ color: "var(--icon-color)" }}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
                <Component
                  m={m}
                  colors={currentColors}
                  editedText={editedText}
                  onEditedTextChange={setEditedText}
                  editing={editing}
                  onEditEnd={() => setEditing(false)}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
